<template>
  <div class="singlehour0">
    <div class="singlehour1">
      <div class="h">{{sum.time}}</div>
      <Switchbox class="switchbox-disabled" :label1="'開放'" :label2="'關閉'" :defaultValue="!disabled" @update="$emit('input', {time: sum.time, value: !$event})"></Switchbox>
    </div>
    <div class="singlehour2">
      <div>預約 <span>{{sum.count}}</span> 組</div>
      <div>人數 <span>{{sum.summary.map(e => (e.reserveNum || 0) + (e.reserveNumChild || 0)).reduce((a, b) => a + b, 0)}}</span> 人</div>
    </div>
  </div>
</template>

<script>
import Switchbox from '../../../components/radio/switchboxs.vue'
// import { postapi } from '../../../store/fetch'
export default {
  components: { Switchbox },
  props: ['sum', 's', 'd', 'store', 'disabled'],
  data () {
    return {
      reasons: [
        '預約額滿',
        '特殊節日僅開放電話預約',
        '活動包場'
      ]
    }
  },
  computed: {
    times () {
      return Array.from(new Set(this.sum.summary.map(e => e.visitTime)))
    }
  },
  methods: {
    // async updateStatus (ev) {
    //   if (this.sum.reason === ev) {
    //   } else {
    //     console.log(ev, 'updateStatus')
    //     const r = await postapi('restaurantStatus/dt', {
    //       date: this.sum.date,
    //       time: this.sum.time,
    //       reason: ev,
    //       store: this.store
    //     })
    //     if (r) {
    //       this.$emit('update')
    //     }
    //   }
    // },
    group (h) {
      return this.sum.summary.filter(e => e.visitTime === h).length
    },
    num (h) {
      return this.sum.summary.filter(e => e.visitTime === h).map(e => (e.reserveNum || 0) + (e.reserveNumChild || 0)).reduce((a, b) => a + b, 0)
    },
    table (h) {
      return [].concat(...this.sum.summary.filter(e => e.visitTime === h).map(e => e.Orders)).filter(e => e.unit === '桌').map(e => e.count).reduce((a, b) => a + b, 0)
    },
    set (h) {
      return [].concat(...this.sum.summary.filter(e => e.visitTime === h).map(e => e.Orders)).filter(e => e.unit === '套').map(e => e.count).reduce((a, b) => a + b, 0)
    }
  }

}
</script>

<style lang="scss">
.singlehour1 {
  display: flex;
  align-items: center;
  .switchbox-disabled {
    box-sizing: border-box;
    margin-left: auto;
    &>input[type=radio] {
      box-sizing: border-box;
      width: 80px;
      height: 40px;
    }
  }
}
</style>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.h {
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.1em;
  width: 90px;
  height: 40px;
  border: 1.5px solid var(--color-pri);
  border-radius: 3px;
}
.singlehour0 {
  display: grid;
  grid-template-columns: 1fr;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  padding: 19px 28px;
  gap: 10px;
  .singlehour1 {
    display: grid;
    grid-template-columns: 1fr 3fr;
    gap: 10px;
  }
  .singlehour2 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    font-size: 14px;
    color: #959595;
    letter-spacing: .1em;
    line-height: 16px;
    height: 40px;
    &>div{
      display: flex;
      align-items: flex-end;
      justify-content: space-evenly;
      vertical-align: baseline;
    }
    span {
      display: inline-flex;
      width: 60px;
      text-align: center;
      justify-content: center;
      font-size: 20px;
      line-height: 23px;
      letter-spacing: .1em;
      color: #000;
    }
  }
}
</style>
